import type { Analytics, EventProperties, SegmentEvent } from '@segment/analytics-next'

const REDACTED_PATHS: string[] = [
  '/sign-up?invitation_code=',
]

const REDACTION_STRING = '[REDACTED]'

export default defineNuxtPlugin((nuxtApp) => {
  function shouldRedact(objectToRedact: NonNullable<SegmentEvent['context']>['page'] | EventProperties) {
    if (!objectToRedact)
      return false

    const propertiesToCheck: Array<keyof typeof objectToRedact> = ['url', 'path', 'referrer']

    return propertiesToCheck.some(property =>
      REDACTED_PATHS.some(redactedPath =>
        objectToRedact[property].includes(redactedPath),
      ),
    )
  }

  (nuxtApp.$segment as Analytics)?.addSourceMiddleware(({ payload, next }) => {
    if (!payload.obj) {
      next(payload)
      return
    }

    if (payload.obj.context && payload.obj.context.page && shouldRedact(payload.obj.context.page)) {
      payload.obj.context.page.url = REDACTION_STRING
      payload.obj.context.page.path = REDACTION_STRING
      payload.obj.context.page.referrer = REDACTION_STRING
      payload.obj.context.page.search = REDACTION_STRING
    }

    if (payload.obj.properties && shouldRedact(payload.obj.properties)) {
      payload.obj.properties.url = REDACTION_STRING
      payload.obj.properties.path = REDACTION_STRING
      payload.obj.properties.referrer = REDACTION_STRING
      payload.obj.properties.search = REDACTION_STRING
    }

    next(payload)
  })
})
